import { useCallback } from 'react';

import { useNavigationContext } from '../context/navigation';

/**
 *
 * @returns functor that creates callback to navigate to the search page
 */
export const useSearchUrl = () => {
    const { searchUrl } = useNavigationContext();
    const onSearch = useCallback(
        (query: string) => {
            const urlParams = new URLSearchParams({ q: query.trim() });
            window.location.href = `${searchUrl}?${urlParams.toString()}`;
        },
        [searchUrl]
    );
    return onSearch;
};
